<template>
    <transition appear name="route-loading">
        <section v-if="isAccountPage" class="account-route-loading" role="status" aria-live="polite">
            <div class="account-route-loading__card">
                <div class="account-route-loading__icon" aria-hidden="true">
                    <v-progress-circular indeterminate color="#f0784c" size="28" width="2" />
                </div>
                <div class="account-route-loading__copy">
                    <span>YOUR ACCOUNT</span>
                    <strong>Preparing your page</strong>
                    <p>Loading your account information…</p>
                </div>
                <div class="account-route-loading__track" aria-hidden="true"><span /></div>
            </div>
        </section>
        <v-card v-else class="d-flex align-center justify-center" flat min-height="85vh">
            <v-col class="subtitle-1 text-center" cols="12"> Loading.. </v-col>
        </v-card>
    </transition>
</template>

<script>
export default {
    computed: {
        isAccountPage() {
            return !!(this.$route && this.$route.meta && this.$route.meta.accountPage)
        }
    },
    page: {
        title: `Loading page...`,
        meta: [{ name: `description`, content: `Loading page...` }]
    }
}
</script>

<style scoped>
.account-route-loading {
    display: flex;
    min-height: 85vh;
    align-items: flex-start;
    justify-content: center;
    padding: clamp(24px, 6vh, 58px) 20px 32px;
    background: radial-gradient(ellipse at 85% 0, rgba(219, 81, 32, 0.15), transparent 36rem),
        linear-gradient(145deg, #292c35, #22252d 65%, #2a2d35);
    font-family: 'Work Sans', 'Roboto', sans-serif;
}
.account-route-loading__card {
    position: relative;
    display: flex;
    width: min(100%, 720px);
    min-height: 112px;
    align-items: center;
    gap: 18px;
    overflow: hidden;
    padding: 22px 24px 25px;
    border: 1px solid rgba(255, 255, 255, 0.11);
    border-top: 2px solid #db5120;
    border-radius: 12px;
    background: linear-gradient(110deg, rgba(219, 81, 32, 0.08), transparent 42%), #282b33;
    box-shadow: 0 14px 32px rgba(0, 0, 0, 0.2);
    animation: account-loading-arrive 260ms ease both;
}
.account-route-loading__icon {
    display: flex;
    width: 48px;
    height: 48px;
    flex: 0 0 48px;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(240, 120, 76, 0.24);
    border-radius: 12px;
    background: rgba(219, 81, 32, 0.1);
}
.account-route-loading__copy {
    min-width: 0;
}
.account-route-loading__copy > span {
    color: #ff9a74;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 1.3px;
}
.account-route-loading__copy strong {
    display: block;
    margin-top: 3px;
    color: #f4f5f8;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: -0.2px;
}
.account-route-loading__copy p {
    margin: 3px 0 0;
    color: #b8bfcc;
    font-size: 11px;
}
.account-route-loading__track {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 3px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.055);
}
.account-route-loading__track span {
    display: block;
    width: 35%;
    height: 100%;
    border-radius: 3px;
    background: linear-gradient(90deg, #c54820, #ff9a74);
    animation: account-loading-progress 1.1s ease-in-out infinite;
}
.route-loading-enter-active,
.route-loading-leave-active {
    transition: opacity 140ms ease;
}
.route-loading-enter,
.route-loading-leave-to {
    opacity: 0;
}
@keyframes account-loading-arrive {
    from {
        opacity: 0;
        transform: translateY(7px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
@keyframes account-loading-progress {
    from {
        transform: translateX(-110%);
    }
    to {
        transform: translateX(310%);
    }
}
@media (prefers-reduced-motion: reduce) {
    .account-route-loading__card,
    .account-route-loading__track span {
        animation: none;
    }
    .route-loading-enter-active,
    .route-loading-leave-active {
        transition: none;
    }
}
@media (max-width: 600px) {
    .account-route-loading {
        min-height: 80vh;
        padding: 20px 12px;
    }
    .account-route-loading__card {
        gap: 12px;
        padding: 18px 16px 21px;
    }
    .account-route-loading__icon {
        width: 42px;
        height: 42px;
        flex-basis: 42px;
    }
}
</style>
